import { createGlobalContext } from '../registry'
import { ComponentState } from './page-state-context'

export interface ComponentPageStateContextValue {
  componentId: string
  componentType: string
  mergeComponentState: (state: Partial<ComponentState['state']>) => void
  setComponentState: (state: ComponentState['state']) => void
}

export const ComponentPageStateContext =
  createGlobalContext<ComponentPageStateContextValue>(
    'ComponentPageStateContext',
    {
      componentId: '',
      componentType: '',
      mergeComponentState: () => undefined,
      setComponentState: () => undefined,
    },
  )
